var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedtickicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3527",
    "data-name": "Group 3527",
    transform: "translate(-1996 -1562)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(1996 1562)",
    fill: "#fdc300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tick_2_",
    "data-name": "tick (2)",
    d: "M155.913,189.113a1.069,1.069,0,0,1-.682.341,1.118,1.118,0,0,1-.69-.349l-4.341-4.341,1.38-1.38,3.659,3.659,9.674-9.744,1.357,1.4Z",
    transform: "translate(1851.547 1392.403)",
    fill: "#d10a11",
    stroke: "#d10a11",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedtickicon);
export default __webpack_public_path__ + "static/media/redtickicon.fb7d394e96934cbc08204c780f13e564.svg";
export { ForwardRef as ReactComponent };